import { Badge, Box, Checkbox, Stack, Text } from '@mantine/core';

import { NavLink } from 'react-router-dom';

const DefaultRouteCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Checkbox defaultChecked={rowData.default} />
        </Box>
    );
};

const DefaultRouteColumn = () => ({
    accessorKey: 'default',
    header: 'Default Route',
    size: 1,
    maxSize: 20,
    Cell: ({ cell }) => <DefaultRouteCell cell={cell} />,
});
export default DefaultRouteColumn;
